module.exports = __webpack_public_path__ + "static/media/file-upload-svgrepo-com.136aeae6.svg";